import Auth from '@/store/actions/auth.js'
import Estico from '@/store/actions/estico'
import Order from '@/store/actions/order'
import Subscription from '@/store/actions/subscription'
import Settings from '@/store/actions/settings'
import Dashboard from '@/store/actions/dashboard'
import Account from '@/store/actions/account'

export default {
  ...Auth,
  ...Estico,
  ...Order,
  ...Subscription,
  ...Settings,
  ...Dashboard,
  ...Account
}
